import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'results',
    name: ROUTE_NAMES.RESULTS,
    component: () => import('../ResultsPage.vue'),
  }
]